import { render, staticRenderFns } from "./compAgencyClassStart.vue?vue&type=template&id=c352c584"
import script from "./compAgencyClassStart.vue?vue&type=script&lang=js"
export * from "./compAgencyClassStart.vue?vue&type=script&lang=js"
import style0 from "./compAgencyClassStart.vue?vue&type=style&index=0&id=c352c584&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports